import { Injectable } from "@angular/core";
import { AlbaranDTO, DocumentoDTO, FacturaDTO, PedidoDTO, PresupuestoDTO } from "../Models/ApiV2/DocumentoDTO";
import { eTipoGrupo, eTipoLineaMovimientos } from "src/GlobalConf";

@Injectable({
    providedIn: 'root'
})
export class MapeosService {
    constructor() { }
    MapeoDocumentoDTOtoFacturaDTO(documento: DocumentoDTO, tipoOperacion: eTipoGrupo): FacturaDTO {
        let facturaDTO: FacturaDTO = new FacturaDTO();
        facturaDTO.id = documento?.id;
        facturaDTO.fecha = documento?.fecha;
        facturaDTO.nombre = documento?.nombre;
        facturaDTO.nif = documento?.nif;
        facturaDTO.nifRepresentante = documento?.nifRepresentante;
        facturaDTO.fechaDocumento = documento?.fechaDocumento;
        facturaDTO.actividad = documento?.actividad;
        facturaDTO.iva = documento?.iva;
        facturaDTO.ivaIncluido = documento?.ivaIncluido;
        facturaDTO.regimenFiscal = documento?.regimenFiscal;
        facturaDTO.fechaValor = documento?.fechaValor;
        facturaDTO.descuento1 = documento?.descuento1;
        facturaDTO.descuento2 = documento?.descuento2;
        facturaDTO.descuento3 = documento?.descuento3;
        facturaDTO.descuento4 = documento?.descuento4;
        facturaDTO.peso = documento?.peso;
        facturaDTO.bultos = documento?.bultos;
        facturaDTO.importeDescuento1 = documento?.importeDescuento1;
        facturaDTO.importeDescuento2 = documento?.importeDescuento2;
        facturaDTO.importeDescuento3 = documento?.importeDescuento3;
        facturaDTO.importeDescuento4 = documento?.importeDescuento4;
        facturaDTO.totalBruto = documento?.totalBruto;
        facturaDTO.totalBases = documento?.totalBases;
        facturaDTO.totalIVA = documento?.totalIVA;
        facturaDTO.totalRecargo = documento?.totalRecargo;
        facturaDTO.totalDocumento = documento?.totalDocumento;
        facturaDTO.totalCargosFinal = documento?.totalCargosFinal;
        facturaDTO.totalAbonosFinal = documento?.totalAbonosFinal;
        facturaDTO.totalRetenciones = documento?.totalRetenciones;
        facturaDTO.totalAPagar = documento?.totalAPagar;
        facturaDTO.fechaPrevista = documento?.fechaPrevista;
        facturaDTO.fechaPrevistaEntrega = documento?.fechaPrevistaEntrega;
        facturaDTO.movimientos = documento?.movimientos;
        for (let i = 0; i < facturaDTO.movimientos.length; i++) {
            facturaDTO.movimientos[i].articulo = {id: facturaDTO.movimientos[i].articulo.id}; 
        }
        facturaDTO.agentes = documento?.agentes;
        if(tipoOperacion == eTipoGrupo.CL){
            facturaDTO.cliente = documento?.cliente;
        }else if (tipoOperacion == eTipoGrupo.PR){
            facturaDTO.proveedor = documento?.proveedor;
        }
        facturaDTO.formaPago = documento?.formaPago;
        facturaDTO.sucursal = documento?.sucursal;
        facturaDTO.almacen = documento?.almacen;
        facturaDTO.tipoTarifaPrecios = documento?.tipoTarifaPrecios;
        facturaDTO.tipoTarifaDescuentos = documento?.tipoTarifaDescuentos;
        facturaDTO.datosDomicilioPrincipal = documento?.datosDomicilioPrincipal;
        facturaDTO.datosDomicilioEnvio = documento?.datosDomicilioEnvio;
        facturaDTO.serie = documento?.serie;
        return facturaDTO
    }

    MapeoDocumentoDTOtoPedidoDTO(documento: DocumentoDTO, tipoOperacion: eTipoGrupo): PedidoDTO {
        let pedidoDTO: PedidoDTO = new PedidoDTO();
        pedidoDTO.id = documento?.id;
        pedidoDTO.fecha = documento?.fecha;
        pedidoDTO.nombre = documento?.nombre;
        pedidoDTO.nif = documento?.nif;
        pedidoDTO.nifRepresentante = documento?.nifRepresentante;
        pedidoDTO.fechaDocumento = documento?.fechaDocumento;
        pedidoDTO.actividad = documento?.actividad;
        pedidoDTO.iva = documento?.iva;
        pedidoDTO.ivaIncluido = documento?.ivaIncluido;
        pedidoDTO.regimenFiscal = documento?.regimenFiscal;
        pedidoDTO.fechaValor = documento?.fechaValor;
        pedidoDTO.descuento1 = documento?.descuento1;
        pedidoDTO.descuento2 = documento?.descuento2;
        pedidoDTO.descuento3 = documento?.descuento3;
        pedidoDTO.descuento4 = documento?.descuento4;
        pedidoDTO.peso = documento?.peso;
        pedidoDTO.bultos = documento?.bultos;
        pedidoDTO.importeDescuento1 = documento?.importeDescuento1;
        pedidoDTO.importeDescuento2 = documento?.importeDescuento2;
        pedidoDTO.importeDescuento3 = documento?.importeDescuento3;
        pedidoDTO.importeDescuento4 = documento?.importeDescuento4;
        pedidoDTO.totalBruto = documento?.totalBruto;
        pedidoDTO.totalBases = documento?.totalBases;
        pedidoDTO.totalIVA = documento?.totalIVA;
        pedidoDTO.totalRecargo = documento?.totalRecargo;
        pedidoDTO.totalDocumento = documento?.totalDocumento;
        pedidoDTO.totalCargosFinal = documento?.totalCargosFinal;
        pedidoDTO.totalAbonosFinal = documento?.totalAbonosFinal;
        pedidoDTO.totalRetenciones = documento?.totalRetenciones;
        pedidoDTO.totalAPagar = documento?.totalAPagar;
        pedidoDTO.fechaPrevista = documento?.fechaPrevista;
        pedidoDTO.fechaPrevistaEntrega = documento?.fechaPrevistaEntrega;
        pedidoDTO.movimientos = documento?.movimientos;
        for (let i = 0; i < pedidoDTO.movimientos.length; i++) {
            if(pedidoDTO.movimientos[i].tipoLinea == eTipoLineaMovimientos.NORMAL){
                pedidoDTO.movimientos[i].articulo = {id: pedidoDTO.movimientos[i].articulo.id}; 
            }
        }
        pedidoDTO.agentes = documento?.agentes;
        if(tipoOperacion == eTipoGrupo.CL){
            pedidoDTO.cliente = documento?.cliente;
        }else if (tipoOperacion == eTipoGrupo.PR){
            pedidoDTO.proveedor = documento?.proveedor;
        }
        pedidoDTO.formaPago = documento?.formaPago;
        pedidoDTO.sucursal = documento?.sucursal;
        pedidoDTO.almacen = documento?.almacen;
        pedidoDTO.tipoTarifaPrecios = documento?.tipoTarifaPrecios;
        pedidoDTO.tipoTarifaDescuentos = documento?.tipoTarifaDescuentos;
        pedidoDTO.datosDomicilioPrincipal = documento?.datosDomicilioPrincipal;
        pedidoDTO.datosDomicilioEnvio = documento?.datosDomicilioEnvio;
        pedidoDTO.serie = documento?.serie;
        return pedidoDTO
    }

    MapeoDocumentoDTOtoAlbaranDTO(documento: DocumentoDTO, tipoOperacion: eTipoGrupo): AlbaranDTO {
        let albaranDTO: AlbaranDTO = new AlbaranDTO();
        albaranDTO.id = documento?.id;
        albaranDTO.fecha = documento?.fecha;
        albaranDTO.nombre = documento?.nombre;
        albaranDTO.nif = documento?.nif;
        albaranDTO.nifRepresentante = documento?.nifRepresentante;
        albaranDTO.fechaDocumento = documento?.fechaDocumento;
        albaranDTO.actividad = documento?.actividad;
        albaranDTO.iva = documento?.iva;
        albaranDTO.ivaIncluido = documento?.ivaIncluido;
        albaranDTO.regimenFiscal = documento?.regimenFiscal;
        albaranDTO.fechaValor = documento?.fechaValor;
        albaranDTO.descuento1 = documento?.descuento1;
        albaranDTO.descuento2 = documento?.descuento2;
        albaranDTO.descuento3 = documento?.descuento3;
        albaranDTO.descuento4 = documento?.descuento4;
        albaranDTO.peso = documento?.peso;
        albaranDTO.bultos = documento?.bultos;
        albaranDTO.importeDescuento1 = documento?.importeDescuento1;
        albaranDTO.importeDescuento2 = documento?.importeDescuento2;
        albaranDTO.importeDescuento3 = documento?.importeDescuento3;
        albaranDTO.importeDescuento4 = documento?.importeDescuento4;
        albaranDTO.totalBruto = documento?.totalBruto;
        albaranDTO.totalBases = documento?.totalBases;
        albaranDTO.totalIVA = documento?.totalIVA;
        albaranDTO.totalRecargo = documento?.totalRecargo;
        albaranDTO.totalDocumento = documento?.totalDocumento;
        albaranDTO.totalCargosFinal = documento?.totalCargosFinal;
        albaranDTO.totalAbonosFinal = documento?.totalAbonosFinal;
        albaranDTO.totalRetenciones = documento?.totalRetenciones;
        albaranDTO.totalAPagar = documento?.totalAPagar;
        albaranDTO.fechaPrevista = documento?.fechaPrevista;
        albaranDTO.fechaPrevistaEntrega = documento?.fechaPrevistaEntrega;
        albaranDTO.movimientos = documento?.movimientos;
        for (let i = 0; i < albaranDTO.movimientos.length; i++) {
            albaranDTO.movimientos[i].articulo = {id: albaranDTO.movimientos[i].articulo.id}; 
        }
        albaranDTO.agentes = documento?.agentes;
        if(tipoOperacion == eTipoGrupo.CL){
            albaranDTO.cliente = documento?.cliente;
        }else if (tipoOperacion == eTipoGrupo.PR){
            albaranDTO.proveedor = documento?.proveedor;
        }
        albaranDTO.formaPago = documento?.formaPago;
        albaranDTO.sucursal = documento?.sucursal;
        albaranDTO.almacen = documento?.almacen;
        albaranDTO.tipoTarifaPrecios = documento?.tipoTarifaPrecios;
        albaranDTO.tipoTarifaDescuentos = documento?.tipoTarifaDescuentos;
        albaranDTO.datosDomicilioPrincipal = documento?.datosDomicilioPrincipal;
        albaranDTO.datosDomicilioEnvio = documento?.datosDomicilioEnvio;
        albaranDTO.serie = documento?.serie;
        return albaranDTO
    }

    MapeoDocumentoDTOtoPresupuestoDTO(documento: DocumentoDTO): PresupuestoDTO {
        let presupuestoDTO: PresupuestoDTO = new PresupuestoDTO();
        presupuestoDTO.id = documento?.id;
        presupuestoDTO.fecha = documento?.fecha;
        presupuestoDTO.nombre = documento?.nombre;
        presupuestoDTO.nif = documento?.nif;
        presupuestoDTO.nifRepresentante = documento?.nifRepresentante;
        presupuestoDTO.fechaDocumento = documento?.fechaDocumento;
        presupuestoDTO.actividad = documento?.actividad;
        presupuestoDTO.iva = documento?.iva;
        presupuestoDTO.ivaIncluido = documento?.ivaIncluido;
        presupuestoDTO.regimenFiscal = documento?.regimenFiscal;
        presupuestoDTO.fechaValor = documento?.fechaValor;
        presupuestoDTO.descuento1 = documento?.descuento1;
        presupuestoDTO.descuento2 = documento?.descuento2;
        presupuestoDTO.descuento3 = documento?.descuento3;
        presupuestoDTO.descuento4 = documento?.descuento4;
        presupuestoDTO.peso = documento?.peso;
        presupuestoDTO.bultos = documento?.bultos;
        presupuestoDTO.importeDescuento1 = documento?.importeDescuento1;
        presupuestoDTO.importeDescuento2 = documento?.importeDescuento2;
        presupuestoDTO.importeDescuento3 = documento?.importeDescuento3;
        presupuestoDTO.importeDescuento4 = documento?.importeDescuento4;
        presupuestoDTO.totalBruto = documento?.totalBruto;
        presupuestoDTO.totalBases = documento?.totalBases;
        presupuestoDTO.totalIVA = documento?.totalIVA;
        presupuestoDTO.totalRecargo = documento?.totalRecargo;
        presupuestoDTO.totalDocumento = documento?.totalDocumento;
        presupuestoDTO.totalCargosFinal = documento?.totalCargosFinal;
        presupuestoDTO.totalAbonosFinal = documento?.totalAbonosFinal;
        presupuestoDTO.totalRetenciones = documento?.totalRetenciones;
        presupuestoDTO.totalAPagar = documento?.totalAPagar;
        presupuestoDTO.fechaPrevista = documento?.fechaPrevista;
        presupuestoDTO.fechaPrevistaEntrega = documento?.fechaPrevistaEntrega;
        presupuestoDTO.movimientos = documento?.movimientos;
        for (let i = 0; i < presupuestoDTO.movimientos.length; i++) {
            presupuestoDTO.movimientos[i].articulo = {id: presupuestoDTO.movimientos[i].articulo.id}; 
        }
        presupuestoDTO.agentes = documento?.agentes;
        presupuestoDTO.cliente = documento?.cliente;
        presupuestoDTO.formaPago = documento?.formaPago;
        presupuestoDTO.sucursal = documento?.sucursal;
        presupuestoDTO.almacen = documento?.almacen;
        presupuestoDTO.tipoTarifaPrecios = documento?.tipoTarifaPrecios;
        presupuestoDTO.tipoTarifaDescuentos = documento?.tipoTarifaDescuentos;
        presupuestoDTO.datosDomicilioPrincipal = documento?.datosDomicilioPrincipal;
        presupuestoDTO.datosDomicilioEnvio = documento?.datosDomicilioEnvio;
        presupuestoDTO.serie = documento?.serie;
        return presupuestoDTO
    }
}